module.exports = [{
      plugin: require('/zeit/4615f2ae/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-11380499-19"},
    }]
